import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap ,LayersControl} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

const MapMarkers = ({ coordinates, popUpShow, showBranchMarkers, chooseCoordinates }) => {
  const map = useMap();
  
  useEffect(() => {
    const bankIcon = L.divIcon({
      className: 'custom-div-icon',
      html: `<div style="background-color: #1a7a73; color: white; padding: 5px; border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; border: 2px solid white;">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="4" y="4" width="16" height="16" rx="1"></rect>
                <line x1="4" y1="9" x2="20" y2="9"></line>
                <line x1="9" y1="20" x2="9" y2="9"></line>
                <line x1="15" y1="20" x2="15" y2="9"></line>
              </svg>
             </div>`,
      iconSize: [30, 30],
      iconAnchor: [15, 30],
      popupAnchor: [0, -30]
    });
    
    const branchIcon = L.divIcon({
      className: 'custom-div-icon',
      html: `<div style="background-color: #FFA100; color: white; padding: 5px; border-radius: 50%; width: 25px; height: 25px; display: flex; align-items: center; justify-content: center; border: 2px solid white;">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"></path><path d="M5 21V7l8-4v18"></path><path d="M19 21V11l-6-4"></path><path d="M9 9v.01"></path><path d="M9 12v.01"></path><path d="M9 15v.01"></path><path d="M9 18v.01"></path></svg>
             </div>`,
      iconSize: [25, 25],
      iconAnchor: [12.5, 25]
    });

    // Fit map to show all markers
    if (coordinates && coordinates.length > 0) {
      const validPoints = coordinates
        .filter(coord => coord.x && coord.y)
        .map(coord => [coord.x, coord.y]);
      
      if (validPoints.length > 0) {
        map.fitBounds(L.latLngBounds(validPoints), {
          padding: [50, 50],
          maxZoom: 14
        });
      }
    }
    
    return () => {};
  }, [coordinates, map]);

  if (!coordinates || coordinates.length === 0) return null;

  return coordinates.map((location, index) => {
    const { x, y, locationId, locationType, popupdata } = location;
    
    // Skip if coordinates are not valid
    if (!x || !y) return null;
    
    // Choose marker type based on location type
    const markerIcon = showBranchMarkers ? 
      (locationType === "Bank" ? 
        L.divIcon({
          className: 'custom-div-icon',
          html: `<div style="background-color:rgb(233, 14, 14); color: white; padding: 5px; border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; border: 2px solid white;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="4" y="4" width="16" height="16" rx="1"></rect>
                    <line x1="4" y1="9" x2="20" y2="9"></line>
                    <line x1="9" y1="20" x2="9" y2="9"></line>
                    <line x1="15" y1="20" x2="15" y2="9"></line>
                  </svg>
                 </div>`,
          iconSize: [30, 30],
          iconAnchor: [15, 30]
          
        }) : 
        L.divIcon({
          className: 'custom-div-icon',
          html: `<div style="background-color: #FFA100; color: white; padding: 5px; border-radius: 50%; width: 25px; height: 25px; display: flex; align-items: center; justify-content: center; border: 2px solid white;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"></path><path d="M5 21V7l8-4v18"></path><path d="M19 21V11l-6-4"></path><path d="M9 9v.01"></path><path d="M9 12v.01"></path><path d="M9 15v.01"></path><path d="M9 18v.01"></path></svg>
                 </div>`,
          iconSize: [25, 25],
          iconAnchor: [12.5, 25]
        })
      ) : 
      L.divIcon({
        className: 'custom-div-icon',
        html: `<div style="background-color: #1a7a73; color: white; padding: 5px; border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; border: 2px solid white;">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>
               </div>`,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
        popupAnchor: [0, -30]
      });
    
    const eventHandlers = chooseCoordinates ? {
      click: () => {
        chooseCoordinates(y, x); // Note: Leaflet uses [lat, lng] while many APIs use [lng, lat]
      }
    } : {};
    
    return (
      <Marker 
        key={`marker-${locationId || index}`}
        position={[x, y]}
        icon={markerIcon}
        eventHandlers={eventHandlers}
      >
        {popUpShow && popupdata && (
          <Popup>
            <div style={{ minWidth: '200px' }}>
              <h6 style={{ 
                margin: '0 0 5px 0', 
                color: locationType === "Bank" ? "#1a7a73" : "#FFA100", 
                fontWeight: 'bold' 
              }}>
                {popupdata.title || "Unknown Location"}
              </h6>
              <div>
                <strong>Type:</strong> {popupdata.type || locationType || "Unknown"}
              </div>
              <div style={{ marginBottom: '5px', marginTop: "5px" }}>
                <strong>Status:</strong> <span style={{ 
                  color: popupdata.status === "Active" ? "green" : "red" 
                }}>
                  {popupdata.status || "Unknown"}
                </span>
              </div>
              {popupdata.email && (
                <div style={{ marginBottom: '5px' }}>
                  <strong>Email:</strong> {popupdata.email}
                </div>
              )}
              {popupdata.contact && (
                <div style={{ marginBottom: '5px' }}>
                  <strong>Contact:</strong> {popupdata.contact}
                </div>
              )}
              <div style={{ marginBottom: '5px' }}>
                <strong>Address:</strong> {popupdata.description || "N/A"}
              </div>
            </div>
          </Popup>
        )}
      </Marker>
    );
  });
};

const MapLegend = ({ showBranchMarkers }) => {
  if (!showBranchMarkers) return null;
  
  return (
    <div style={{
      position: 'absolute',
      bottom: '10px',
      right: '10px',
      backgroundColor: 'white',
      padding: '5px 10px',
      borderRadius: '4px',
      boxShadow: '0 1px 5px rgba(0,0,0,0.2)',
      zIndex: 1000,
      fontSize: '12px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
        <div style={{ 
          backgroundColor: '#1a7a73', 
          width: '12px', 
          height: '12px', 
          borderRadius: '50%',
          marginRight: '5px'
        }}></div>
        <span>Bank</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ 
          backgroundColor: '#FFA100', 
          width: '12px', 
          height: '12px', 
          borderRadius: '50%',
          marginRight: '5px'
        }}></div>
        <span>Branch</span>
      </div>
    </div>
  );
};

const CustomMapBranch = (props) => {
  const {
    coordinates,
    zoom = 13,
    popUpShow = true,
    showBranchMarkers = false,
    chooseCoordinates,
    closeMapModal
  } = props;

  // Calculate center point from coordinates
  const getCenter = () => {
    if (coordinates && coordinates.length > 0) {
      const validCoords = coordinates.filter(coord => coord.x && coord.y);
      if (validCoords.length > 0) {
        return [validCoords[0].x, validCoords[0].y];
      }
    }
    return [20.5937, 78.9629]; // Default to center of India
  };

  const center = getCenter();

  if (!coordinates || coordinates.length === 0) {
    return (
      <div style={{ 
        width: '100%', 
        height: '100%', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        color: '#666'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', marginBottom: '10px' }}>
            <span role="img" aria-label="map">🗺️</span>
          </div>
          <p>No location data available</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <MapContainer 
        center={center} 
        zoom={zoom} 
        style={{ width: '100%', height: '100%' }}
        zoomControl={true}
        attributionControl={false}
      >
        <LayersControl position="topright" collapsed={false}>
                      <LayersControl.BaseLayer name="Road View">
                        <TileLayer
                          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                      </LayersControl.BaseLayer>
         
                      <LayersControl.BaseLayer name="Satellite View">
                        <TileLayer
                          attribution="&copy; Google Maps"
                          url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                          maxZoom={20}
                          subdomains={["mt0", "mt1", "mt2", "mt3"]}
                        />
                      </LayersControl.BaseLayer>
         
                      <LayersControl.BaseLayer checked name="Terrain View">
                        <TileLayer
                          attribution="&copy; Google Maps"
                          url="https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
                          maxZoom={20}
                          subdomains={["mt0", "mt1", "mt2", "mt3"]}
                        />
                      </LayersControl.BaseLayer>
         
                      <LayersControl.BaseLayer name="Hybrid View">
                        <TileLayer
                          attribution="&copy; Google Maps"
                          url="https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
                          maxZoom={20}
                          subdomains={["mt0", "mt1", "mt2", "mt3"]}
                        />
                      </LayersControl.BaseLayer>
                    </LayersControl>
        <MapMarkers 
          coordinates={coordinates} 
          popUpShow={popUpShow} 
          showBranchMarkers={showBranchMarkers} 
          chooseCoordinates={chooseCoordinates}
        />
      </MapContainer>
      <MapLegend showBranchMarkers={showBranchMarkers} />
    </div>
  );
};

export default CustomMapBranch;